import { storageNewOrderPrices } from '@/utils/newOrder';

const initPrices = () => {
  const value = storageNewOrderPrices.get();
  if (String(value) === '2') {
    return 2;
  }

  return 0;
};

export default {
  modelsZgi: null,
  modelsCut: null,
  modelsOpt: null,
  materialsZgi: [],
  materialsCut: [],
  materialsOpt: [],
  configCut: null,
  orderEdit: null,
  setList: [],
  payment: null,
  optionsList: [],
  orderCopy: {
    path: null,
    data: null,
  },
  prices: initPrices(),
  zgiTender: false,
  cutTender: false,
  order: [],
  isDisabledAddToCart: false,
};
